import React from "react";

export const ArthaLogo = ({ size = 28, variant = "dark", withMark = true }) => {
  const textColor = variant === "dark" ? "#0D0D0C" : "#FAF7F2";
  return (
    <div className="flex items-center gap-2" data-testid="artha-logo">
      {withMark && <Sunflower size={size} />}
      <span
        className="font-serif-display tracking-tight"
        style={{ color: textColor, fontSize: size * 0.95, lineHeight: 1 }}
      >
        Artha
      </span>
    </div>
  );
};

export const Sunflower = ({ size = 28, color = "#F5A623" }) => {
  const petals = Array.from({ length: 12 });
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" aria-label="Artha sunflower" className="shrink-0">
      <g>
        {petals.map((_, i) => {
          const angle = (i * 360) / petals.length;
          return (
            <ellipse
              key={i}
              cx="50" cy="18" rx="6" ry="16"
              fill={color}
              transform={`rotate(${angle} 50 50)`}
            />
          );
        })}
        <circle cx="50" cy="50" r="14" fill={color} />
        <circle cx="50" cy="50" r="10" fill="none" stroke="#0D0D0C" strokeWidth="1" opacity="0.15" />
        <g stroke="#0D0D0C" strokeWidth="0.4" opacity="0.2">
          <line x1="42" y1="50" x2="58" y2="50" />
          <line x1="50" y1="42" x2="50" y2="58" />
          <line x1="44" y1="44" x2="56" y2="56" />
          <line x1="56" y1="44" x2="44" y2="56" />
        </g>
      </g>
    </svg>
  );
};

export const SunflowerGlyph = ({ size = 120 }) => (
  <div className="relative inline-block">
    <div className="sunflower-spin">
      <Sunflower size={size} />
    </div>
  </div>
);
